/**
 * This file is part of the "Awaken Media" project.
 *
 * (c) 2020 - CanalPlus International
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
import React, { useCallback } from 'react';

import {
  Modal,
  Content,
  PictureWrapper,
  Picture,
  TextWrapper,
  Title,
  StyledRaw,
  StyledButton,
  ButtonText
} from './styles/components';
import { Props } from './types';

// Default style of the modal is overwritten in the Modal presentational component

const PopIn = ({
  id,
  title,
  text,
  picture,
  link,
  isOpen,
  togglePopIn
}: Props) => {
  const renderButton = useCallback(
    (link: Props['link']) => {
      if (!link) {
        return;
      }

      if (link.url) {
        return (
          <StyledButton to={link.url} variant="tertiary">
            <ButtonText>{link.label}</ButtonText>
          </StyledButton>
        );
      } else {
        return (
          <StyledButton onClick={togglePopIn} variant="tertiary">
            <ButtonText>{link.label}</ButtonText>
          </StyledButton>
        );
      }
    },
    [togglePopIn]
  );

  return (
    <div>
      <Modal id={id} isOpen={isOpen} contentLabel={title}>
        <Content>
          {picture && (
            <PictureWrapper data-testid="popin-picture-wrapper">
              <Picture
                url={picture.url}
                alt={picture.alt}
                sizes={{
                  tablet: { w: 380, h: 380 },
                  phone: { w: 278, h: 278 }
                }}
              ></Picture>
            </PictureWrapper>
          )}
          <TextWrapper>
            {title && <Title data-testid="popin-title">{title}</Title>}
            <StyledRaw html={text} />
            {renderButton(link)}
          </TextWrapper>
        </Content>
      </Modal>
    </div>
  );
};

export default PopIn;
